import YourSleepPatternsSection from './YourSleepPatternsSection'

export default YourSleepPatternsSection
